// extracted by mini-css-extract-plugin
module.exports = {"Layout":"style-module--Layout--31JhN"};